// @index(!types)
export {default as IndexEndpoint} from './IndexEndpoint'
export {default as MenuPageItemsEndpoint} from './MenuPageItemsEndpoint'
export {default as MenuPageItemDocument} from './MenuPageItemDocument'
export {default as PageDocument} from './PageDocument'
// /index

export * from './types'